import React from "react"
import PropTypes from "prop-types"
import { Container } from "./styled"
function Address(props) {
  return (
    <>
      <Container>
        <section className="text-gray-600 body-font relative">
          <div className="absolute inset-0 bg-gray-300">
            <iframe
              width="100%"
              height="100%"
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3821.323865106945!2d-49.295038!3d-16.7106847!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x935ef733ece17093%3A0x51b5c7911f9f7a3f!2sFerreira%20%26%20Faustino%20Advogados%20Associados!5e0!3m2!1spt-BR!2sbr!4v1662428208903!5m2!1spt-BR!2sbr"
            />
           
          </div>
          <div className="container py-24 mx-auto flex">
            <div className="lg:w-3/3 md:w-1/2 bg-white rounded-lg p-8 flex flex-col md:ml-auto w-full mt-10 md:mt-0 relative z-10 shadow-md">
              <h3 className="text-gray-900 text-lg mb-1 font-medium title-font">
                Horários:
              </h3>
              <p className="leading-relaxed  text-gray-600">
                Segunda a Sexta, das 8:00 as 18:00hrs.
              </p>
              <h3 className="text-gray-900 text-lg mb-1 font-medium title-font">
                Local:
              </h3>
              <p className="leading-relaxed  text-gray-600">
                R. C-159, 360 - Jardim América, Goiânia - GO, 74255-140
              </p>
              <h3 className="text-gray-900 text-lg mb-1 font-medium title-font">
                Telefone:
              </h3>
              <p className="leading-relaxed  text-gray-600">
               (62) 98404-7472<br />
              </p>
              <h3 className="text-gray-900 text-lg mb-1 font-medium title-font">
                Email:
              </h3>
              <p className="leading-relaxed  text-gray-600">
               william-gyn97@hotmail.com
              </p>
            </div>
          </div>
        </section>
      </Container>
    </>
  )
}

Address.defaultProps = {
  theme: "Custom",
}

Address.propTypes = {
  theme: PropTypes.string.isRequired,
}

export default Address
